import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4 12H20" vectorEffect="non-scaling-stroke" />
		<Path d="M17 20H7V16H17V20Z" fill="currentColor" stroke="none" />
		<Path d="M17 8H7V4H17V8Z" fill="currentColor" stroke="none" />
	</SVG>
);
